import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Col, Container, Row, Image } from 'react-bootstrap';
import Navbar from 'react-bootstrap/Navbar';
import AUTH_LOGOUT_URL from '../../constants/auth';

import './index.css';

const NoAccessScreen = () => {
  const [ t ] = useTranslation();

  return (
    <div>
      <Navbar >
        <Navbar.Brand href="#"><Image src="favicon.png" rounded />{t('navbar.brand')} {global.appVersion}</Navbar.Brand>
          <Navbar.Toggle />
          <Navbar.Collapse className="justify-content-end">
            <Row>
              <Col>
                <Button variant="outline-dark" href={AUTH_LOGOUT_URL}>{`${t('navbar.logout')}`}</Button>
              </Col>
            </Row>
          </Navbar.Collapse>
      </Navbar>
      <Container align="center">
        <h2>{t('common.noAccess')}</h2>
      </Container>
   </div>
  );
};

export default NoAccessScreen;
